import Markdown from 'react-markdown'
import raw from 'raw.macro'

const terms = raw('../assets/terms.md')

const Terms = () => (
  <div className='row center'>
    <div className='col-8'>
      <Markdown>
        { terms }
      </Markdown>
    </div>
  </div>
)

export default Terms
